/** Drag the whole lane bar: shift the window preserving length, clamped to
 *  [0, clipDuration]. A window longer than the clip pins to 0. */
export function applyLaneMove(
  { start, end, deltaSec, clipDuration }:
  { start: number; end: number; deltaSec: number; clipDuration: number },
): { start: number; end: number } {
  const len = end - start;
  const maxStart = Math.max(0, clipDuration - len);
  const s = Math.min(Math.max(0, start + deltaSec), maxStart);
  return { start: s, end: s + len };
}
